<template>
  <div class="detail">
    <navb title="任务明细" rollcolor="#f1f2f3" :alwaysshow="true" @back="back"
      backarrow="//file.40017.cn/appresource/image/ec/icon_navi_back.png" />
    <div class="head-box">
      <div class="item">
        <p class="top">{{type==1?'飞行':'入住'}}次数</p>
        <p class="bottom">{{currentCount}}次</p>
      </div>
      <div class="line"></div>
      <div class="item">
        <p class="top">总金额</p>
        <p class="bottom">¥ {{sum}}</p>
      </div>
    </div>
    <div class="list-box">
      <div class="header border_b">
        <p class="left">{{type==1?'航段':'酒店'}}</p>
        <p class="center">{{type==1?'出发日期':'入住日期'}}</p>
        <p class="right">金额</p>
      </div>
      <ul class="list">
        <li class="item border_b" v-for="(item,idx) in orderDetailList" :key="idx">
          <p class="left">{{item.name}}</p>
          <p class="center">{{item.bookTime.slice(0,10)}}</p>
          <p class="right">¥ {{item.amount}}</p>
        </li>
      </ul>
    </div>
    <noresult v-if="isShowResult" :type="1" :tips="'暂无'+(type==1?'机票飞行次数':'酒店入住次数')" />
  </div>
</template>
<script>
import navb from "./components/nav"
import noresult from "./components/netError"
import { getTaskStatus, tianyanCode } from "@/api/tin1"
let userKey, activityCode
export default {
  components: { navb, noresult },
  data() {
    return {
      isShowResult: false,
      currentCount: 0,
      orderDetailList: [],
      type: this.$route.query.type || '1',
      sum: 0
    }
  },
  created() {
    this.$loading.show()
    document.body.style.backgroundColor = "#f1f2f3"
    activityCode = this.$route.query.code || ''
    _multi_bridge_ready(() => {
      window._tc_bridge_user.user_login({
        callback: (res) => {
          const data = JSON.parse(res.CBData);
          console.log(data);
          userKey = data.memberInfo.securityToken
          if (userKey) {
            this.getInfo()
          } else {
            window._tc_bridge_util.set_webview_back()
          }
        }
      })
    })
    
  },
  methods: {
    getInfo() {
      getTaskStatus({
        projectId: this.type,
        tianyanCode,
        activityCode,
        source: '1',
        userKey
      }).then(res => {
        console.log(res)
        this.$loading.hide()
        if (res.code == '0') {
          this.status = res.data.status
          if (this.status != 1) {
            this.currentCount = res.data.currentCount
            this.orderDetailList = res.data.orderDetail || []
            console.log(this.orderDetailList.length)
            if (this.orderDetailList.length > 0) {
              let sum = 0
              res.data.orderDetail.forEach(item => {
                sum += +item.amount
              });
              this.sum = sum
            } else {
              this.sum = 0
              this.isShowResult = true
            }
          }
        } else {
          this.isShowNonet = true
        }
      })
    },
    back() {
      window._tc_bridge_util.set_webview_back()
    }
  }
}
</script>
<style lang="less" scoped>
.detail {
  padding-bottom: 70px;
  .head-box {
    display: -webkit-box;
    padding-top: 30px;
    .item {
      width: 0;
      -webkit-box-flex: 1;
      text-align: center;
      .top {
        color: #82848c;
        font-size: 12px;
        line-height: 14px;
      }
      .bottom {
        font-size: 24px;
        line-height: 28px;
        color: #37383d;
        font-weight: bold;
        padding-top: 15px;
      }
    }
    .line {
      width: 2px;
      height: 40px;
      background: #e7e7eb;
      margin-top: 5px;
    }
  }
  .list-box {
    background: #fff;
    margin: 30px 15px 0;
    border-radius: 4px;
    overflow: hidden;
    .header {
      display: -webkit-box;
      // border-bottom: 1px solid #eee;
      padding: 0 17px;
      p {
        color: #82848c;
      }
    }
    .list {
      padding: 0 17px;
      .item {
        display: -webkit-box;
        // border-bottom: 1px solid #eee;
        .left,
        .center {
          color: #333;
        }
        .right {
          color: #be4949;
        }
      }
      .item:last-child {
        border-bottom: none;
      }
    }
    .left,
    .center,
    .right {
      -webkit-box-flex: 1;
      width: 0;
      height: 52px;
      line-height: 52px;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .left {
      text-align: left;
    }
    .center {
      text-align: center;
    }
    .right {
      text-align: right;
    }
  }
}
/*边框*/
.border_l,
.border_t,
.border_b,
.border_r {
  border-width: 0;
}

.border_l {
  border-left: #dcdcdc solid;
  border-left-width: 1px;
}

.border_t {
  border-top: #dcdcdc solid;
  border-top-width: 1px;
}

.border_r {
  border-right: #dcdcdc solid;
  border-right-width: 1px;
}

.border_b {
  border-bottom: #dcdcdc solid;
  border-bottom-width: 1px;
}

.border_l,
.border_r {
  -webkit-border-image: url(//file.40017.cn/appresource/image/tin1/border2.png) 0 2 stretch;
  border-image: url(//file.40017.cn/appresource/image/tin1/border2.png) 0 2 stretch;
}

.border_t,
.border_b {
  -webkit-border-image: url(//file.40017.cn/appresource/image/tin1/border.png) 2 0 stretch;
  border-image: url(//file.40017.cn/appresource/image/tin1/border.png) 2 0 stretch;
}
</style>